<mat-dialog-content class="embrace-policy">
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
		class="embrace-policy__heading"
	>
		Embrace Policy Terms & Conditions
	</epi-heading>
	<p class="embrace-policy__sub-header">
		We believe in being open, honest, and transparent. That's why the Embrace Policy Terms & Conditions are easily
		accessible, so you can review them before you buy.
	</p>
	<section class="embrace-policy__listgroup u-margin-top-large">
		<p class="embrace-policy__content u-margin-block-small">
			Your pet's eligibility for an Embrace Pet Insurance plan can be determined only after being underwritten
			online or
			over the phone. All new and renewal policies are issued by American Modern Insurance Group, an A+ Superior
			rated
			company.
		</p>
		<p class="embrace-policy__content u-margin-block-small">
			<strong>Please Note:</strong> These are sample policy documents for new policies only. <strong>Current
				Policyholders </strong> can refer to their terms and conditions through their MyEmbrace account online
			or in the
			Embrace Pet Insurance mobile app.
		</p>
		<label>
			<strong>State</strong>
		</label>
		<select
			class="embrace-policy__input"
			input-id="policyState"
			data-quat="input_policyState"
			(change)="handleEpiSelectionChange($event)"
		>
			<option
				hidden
				disabled
				selected
			>Select a state</option>
			<option
				*ngFor="let state of states; let i = index"
				id="policyStateOption{{ i }}"
				[value]="state.abbreviation"
				slot="option"
				attr.data-quat="input_policyStateOption{{ i }}"
			>{{ state.abbreviation }} - {{ state.name }}</option>
		</select>
		<p class="embrace-policy__content__full u-margin-top-small">
			<a
				class="embrace-policy__download-button"
				[href]="downloadLink"
				target="_blank"
				[ngClass]="{ 'disabled': !downloadLink || downloadLink === '', 'white-text': isColorMatch }"
			>Download Terms & Conditions</a>
		</p>
	</section>
</mat-dialog-content>